<template>
  <img
    class="symbol"
    :style="`width: ${width}px; height: ${height}px`"
    src="../assets/symbol.svg"
    alt="Vale Saúde Sempre"
  />
</template>

<script>
export default {
  name: 'LogoIcon',
  props: ['width', 'height']
};
</script>

<style lang="scss">
.symbol {
  display: block;
  margin: 0 auto;
}
</style>
